// extracted by mini-css-extract-plugin
export default {"errorBtn":"PendingManager_errorBtn__p3RS+"};